export const APP_TERMS = {
    error_title: "Error",
    zip_code_title: "Clinic ZIP code",
    zip_code_required_validation: "Please enter Clinic ZIP code",
    zip_code_invalid_validation: "Please enter a valid Clinic ZIP code",
    file_upload_invalid_validation: "Please attach a minimum of one file",
    case_service_invalid_validation: "Please add a minimum of one service",
    "date_1_format": "MM-dd-yyyy",
    generic_case: "Case",
    generic_invoice: "Invoice",
    generic_accounting: "Accounting",
    generic_draft: "Draft",
    generic_patients: "Patients",
    generic_details: "Details",
    generic_name: "Name",
    generic_first: "First",
    generic_last: "Last",
    generic_gender: "Gender",
    generic_gender_male: "Male",
    generic_gender_female: "Female",
    generic_gender_other: "Other",
    generic_submitted: "Submitted",
    generic_submitting: "Submitting",
    generic_completed: "Completed",
    generic_next: "Next",
    generic_appointement: "Appoinment",
    generic_study: "Study",
    generic_purpose: "Purpose",
    generic_date: "Date",
    generic_scan: "Scan",
    generic_office: "Office",
    generic_referring: "Referring",
    generic_doctor: "Doctor",
    generic_add: "Add",
    generic_edit: "Edit",
    generic_services: "Services",
    generic_upload: "Upload",
    generic_files: "Files",
    generic_report: "Report",
    generic_result: "Result",
    generic_summary: "Summary",
    generic_documents: "Documents",
    generic_general: "General",
    generic_description: "Description",
    impaction_label: "Impaction",
    implant_label: "Implant",
    orthodontic_label: "Orthodontic",
    pathology_label: "Pathology",
    sinus_label: "Sinus",
    tmd_pain_label: "TMD/Pain",
    airway_label: "Airway",
    platform_id_label: "Platform ID",
    patient_chart_no:'Patient Chart No (Optional)',
    platform_id_placeholder: "Enter user's platform ID if available",
    patient_chart_no_placeholder:"Enter patient's Chart No if available",
    created_case_list_title: "Created Cases",
    draft_case_list_title: "Draft Cases",
    submitted_case_list_title: "Submitted Cases",
    completed_case_list_title: "Completed Cases",
    add_case_title: "Add Case",
    region_interest_cases_comments_label: "Region Interest/Cases Comments",
    cases_comment_label: "Cases Comments",
    date_of_birth_label: "Date Of Birth",
    download_failed: "Download Failed"
}